module.exports = __webpack_public_path__ + "static/media/41_tn.49cbb516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/41_tn.jpg
// module id = 677
// module chunks = 0